/* Native Shopify forms remain responsible for cart and accelerated payment. */
(() => {
  function init(root) {
    if (root.srPortableCleanup) root.srPortableCleanup();
    const controller = new AbortController(), options = {signal:controller.signal};
    const on = (element,event,handler) => element && element.addEventListener(event,handler,options);
    const find = selector => root.querySelector(selector);
    const prefix = 'sr-portable-' + root.dataset.sectionId + '-';
    const id = name => root.querySelector('[id="' + prefix + name + '"]');
    const data = JSON.parse(find('[data-sr-data]').textContent);
    const form = find('form.sr-portable-form'), select = find('[data-sr-select]'), qty = form.querySelector('[name="quantity"]');
    const submit = find('[data-sr-submit]'), feedback = find('[data-sr-feedback]'), hero = find('[data-sr-hero]');
    const variant = () => data.variants.find(v => String(v.id) === select.value);
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:data.currency}).format(value/100) + ' ' + data.currency;
    function quantity() {
      const v = variant(); if (!v) return 1;
      const min = Number(v.min) || 1, step = Number(v.step) || 1;
      let value = Math.max(min,Math.round((Number(qty.value)-min)/step)*step+min);
      if (!Number.isFinite(value)) value = min;
      if (v.max != null) value = Math.min(value,min+Math.floor((Number(v.max)-min)/step)*step);
      qty.value = Math.max(min,value);
      find('[data-sr-total]').textContent = 'Item total: ' + money(v.price * Number(qty.value));
      return Number(qty.value);
    }
    const optionButtons = [...root.querySelectorAll('[data-option-index]')];
    const summary = v => (v.options || [v.title]).map(value => /^\+\d{3}$/.test(value) ? '+'+(Number(value.slice(1))/100).toFixed(2) : value.split('/')[0].trim()).join(' · ');
    function syncOptions(v) {
      optionButtons.forEach(button => {
        const index = Number(button.dataset.optionIndex), value = button.dataset.optionValue;
        // Frame choice filters strengths; strength choice keeps the selected frame.
        const candidates = data.variants.filter(candidate => candidate.options[index] === value &&
          (index === 0 || candidate.options.every((option, i) => i === index || option === v.options[i])));
        const exists = candidates.length > 0, available = candidates.some(candidate => candidate.available);
        button.disabled = !exists || (index !== 0 && !available);
        button.setAttribute('aria-pressed', String(v.options[index] === value));
        const status = !exists ? 'Unavailable' : !available ? 'Sold out' : '';
        button.querySelector('[data-option-status]').textContent = status;
        button.setAttribute('aria-label', button.querySelector('span').textContent + (status ? ' — ' + status : ''));
      });
    }
    function update(changeURL=true,resetQuantity=true,resetImage=true) {
      const v = variant(); if (!v) return;
      submit.disabled = !v.available; submit.textContent = v.available ? 'Add to cart ↗' : 'Sold out';
      find('[data-sr-price]').textContent = v.formatted;
      find('[data-sr-sticky-price]').textContent = v.formatted;
      const compare = find('[data-sr-compare]'); compare.textContent = v.compare; compare.hidden = !v.compare;
      find('[data-sr-selection]').textContent = 'Selected: ' + summary(v) + (v.available ? '' : ' · Sold out');
      find('[data-sr-sticky-selection]').textContent = summary(v);
      syncOptions(v);
      qty.min = v.min; qty.step = v.step;
      if (v.max != null) qty.max = v.max; else qty.removeAttribute('max');
      if (resetQuantity) qty.value = v.min;
      quantity();
      find('[data-sr-quantity-rule]').textContent = Number(v.min)>1 || Number(v.step)>1 || v.max!=null ? 'Minimum '+v.min+' · Increments of '+v.step+(v.max!=null?' · Maximum '+v.max:'') : '';
      const accelerated=find('[data-sr-accelerated]'); if (accelerated) accelerated.hidden=!v.available;
      if(resetImage){hero.src=v.image; hero.alt=summary(v)+' portable readers';}
      find('[data-sr-gallery-tag]').textContent=summary(v);
      find('[data-sr-gallery-caption]').textContent='Selected product option';
      root.querySelectorAll('.thumb').forEach(b=>b.setAttribute('aria-pressed',String(String(v.imageId)===b.dataset.imageId)));
      feedback.hidden=true;
      if (changeURL) {const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(history.state,'',u);}
      qty.dispatchEvent(new Event('change',{bubbles:true}));
    }
    on(select,'change',()=>update());
    on(qty,'change',quantity);
    optionButtons.forEach(button => on(button, 'click', () => {
      if (button.disabled) return;
      const current = variant(), index = Number(button.dataset.optionIndex);
      const desired = [...current.options]; desired[index] = button.dataset.optionValue;
      let next = data.variants.find(candidate => candidate.options.every((value, i) => value === desired[i]));
      // An absent combination falls back to a real variant of the chosen frame.
      if (!next && index === 0) next = data.variants.find(candidate => candidate.options[0] === desired[0] && candidate.available) || data.variants.find(candidate => candidate.options[0] === desired[0]);
      if (!next) return;
      select.value = String(next.id);
      select.dispatchEvent(new Event('change', {bubbles:true}));
      if (button.hasAttribute('data-scroll-buy')) {
        id('buy').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        const target = optionButtons.find(b => !b.hasAttribute('data-scroll-buy') && Number(b.dataset.optionIndex) === index && b.dataset.optionValue === desired[index]);
        target?.focus({preventScroll:true});
      }
    }));
    root.querySelectorAll('[data-quantity]').forEach(b=>on(b,'click',()=>{qty.value=quantity()+Number(b.dataset.quantity)*Number(variant().step);quantity();qty.dispatchEvent(new Event('change',{bubbles:true}));}));
    root.querySelectorAll('.thumb').forEach(b=>on(b,'click',()=>{
      hero.src=b.dataset.src;hero.alt=b.dataset.alt;
      root.querySelectorAll('.thumb').forEach(t=>t.setAttribute('aria-pressed',String(t===b)));
      find('[data-sr-gallery-caption]').textContent=b.dataset.alt;
    }));
    on(find('[data-sr-help]'),'click',()=>{const panel=id('inline-help');panel.hidden=!panel.hidden;find('[data-sr-help]').setAttribute('aria-expanded',String(!panel.hidden));});
    on(find('[data-sr-country]'),'change',e=>{const o=e.target.selectedOptions[0];find('[data-sr-delivery]').textContent=o.textContent+' delivery: '+o.dataset.days+' business days after dispatch.';});
    on(form,'submit',e=>{
      if(!variant()?.available){e.preventDefault();feedback.hidden=false;feedback.textContent='This option is sold out. Please choose another option.';return;}
      quantity();
      // Do not intercept native accelerated checkout or replace its payment flow.
      if(e.submitter===submit){submit.textContent='Adding…';submit.disabled=true;}
    });
    on(window,'pageshow',()=>update(false,false,new URL(location.href).searchParams.has('variant')));
    on(window,'popstate',()=>{const v=new URL(location.href).searchParams.get('variant');if(data.variants.some(x=>String(x.id)===v)){select.value=v;select.dispatchEvent(new Event('change',{bubbles:true}));}});
    const sticky=find('.mobile-buy');let queued=false;
    function stickyState(){queued=false;sticky.classList.toggle('visible',form.getBoundingClientRect().bottom<0&&root.getBoundingClientRect().bottom>100);}
    const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(stickyState);}};
    on(window,'scroll',schedule);on(window,'resize',schedule);
    root.srPortableCleanup=()=>{controller.abort();root.classList.remove('ready');};
    update(false,false,new URL(location.href).searchParams.has('variant'));root.classList.add('ready');stickyState();
  }
  const all=()=>document.querySelectorAll('[data-sr-portable]').forEach(root=>{if(!root.classList.contains('ready'))init(root);});
  if(!window.sunrayPortableRegistered){window.sunrayPortableRegistered=true;document.addEventListener('shopify:section:load',all);document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-sr-portable]').forEach(r=>r.srPortableCleanup?.()));}
  all();
})();
